import React from 'react';
export var BlockLogo = function (_a) {
    var image = _a.image, align = _a.align, width = _a.width, height = _a.height;
    return (React.createElement("div", { style: { width: '100%', textAlign: align } },
        React.createElement("img", { alt: 'image', width: width || '130px', src: "".concat(process.env.REACT_APP_SERVER).concat(image) })));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockLogo.tsx
// module id = 257
// module chunks = 0